$(function () {
    $(document).ready(function () {
        $('.country-dropdown').change(function () {

            var countryDropdown = $(this);
            var container = countryDropdown.parents('.wt-sales-rep-widget__inner');
            var stateDropdownContainer = countryDropdown.parents('.sales-rep-filters').find('.state-filter');
            var cityInput = container.find('.city-input');
            var zipInput = container.find('.zip-input');
            var loader = container.find('.sales-rep-loader');
            var salesReps = container.find('.sales-reps');

            zipInput.val('');
            zipInput.parent().hide();
            cityInput.val('');
            cityInput.parent().hide();
            salesReps.html('');
            stateDropdownContainer.hide();
            loader.css('display', 'flex');

            var url = new URL(window.location);
            var param = $(this).val();

            if (param.length == 0) {
                url.searchParams.delete('country');
            }
            else {
                url.searchParams.set('country', $(this).val());
            }

            url.searchParams.delete('state');

            window.history.pushState({}, '', url);

            $.ajax({
                url: '/SalesRep/GetFindARepData',
                method: 'GET',
                data: { 'countryCodeName': $(this).val() },
                success: function (resp) {
                    var data = JSON.parse(resp);

                    var filters = countryDropdown.parents('.sales-rep-filters');
                    var zipInput = filters.find('.zip-filter');

                    if (data.DisplayZip) {
                        zipInput.css('display', 'flex');
                    }
                    else {
                        zipInput.hide();
                    }

                    // update state dropdown values
                    var stateDropdown = filters.find('.state-dropdown');
                    var sDefaultOption = stateDropdown.find('option').first();
                    var html = sDefaultOption.prop('outerHTML');

                    if (data.States.length > 0) {
                        for (var i = 0; i < data.States.length; i++) {
                            html += '<option value="' + data.States[i].SalesRepStateProvinceCodeName + '">';
                            html += data.States[i].SalesRepStateProvinceDisplayName;
                            html += '</option>';
                        }

                        stateDropdown.html(html);
                        stateDropdownContainer.show();
                    }

                    // update the sales rep list
                    var repsHtml = '';

                    if (data.Reps.length > 0) {
                        repsHtml = GetSalesRepsHtml(data.Reps);
                    }

                    // update sales rep listing
                    salesReps.html(repsHtml);

                    // hide loading icon
                    loader.hide();
                }
            });

        });

        $('.state-dropdown').change(function () {
            var stateDropdown = $(this);
            var container = stateDropdown.parents('.wt-sales-rep-widget__inner');
            var filterContainer = stateDropdown.parents('.sales-rep-filters')
            var countryDropdown = filterContainer.find('.country-dropdown');
            var cityInput = filterContainer.find('.city-input');
            var loader = container.find('.sales-rep-loader');
            var salesReps = container.find('.sales-reps');

            salesReps.html('');
            cityInput.val('');
            cityInput.parent().hide();
            loader.css('display', 'flex');

            var url = new URL(window.location);
            var param = $(this).val();

            if (param.length == 0) {
                url.searchParams.delete('state');
            }
            else {
                url.searchParams.set('state', $(this).val());
            }

            window.history.pushState({}, '', url);

            $.ajax({
                url: '/SalesRep/GetFindARepData',
                method: 'GET',
                data: { 'countryCodeName': countryDropdown.val(), 'stateCodeName': stateDropdown.val() },
                success: function (resp) {
                    var data = JSON.parse(resp);

                    var filters = stateDropdown.parents('.sales-rep-filters');
                    var cityInput = filters.find('.city-filter');

                    if (data.DisplayCity) {
                        cityInput.css('display', 'flex');
                    }
                    else {
                        cityInput.hide();
                    }

                    // update the sales rep list
                    var repsHtml = '';

                    if (data.Reps.length > 0) {
                        repsHtml = GetSalesRepsHtml(data.Reps);
                    }

                    // update sales rep listing
                    salesReps.html(repsHtml);

                    // hide loading icon
                    loader.hide();
                }
            });
        });

        $('.zip-filter-btn').click(function () {
            var container = $(this).parents('.wt-sales-rep-widget__inner');
            var countryDropdown = $(this).parents('.sales-rep-filters').find('.country-dropdown');
            var stateDropdown = $(this).parents('.sales-rep-filters').find('.state-dropdown');
            var loader = container.find('.sales-rep-loader');
            var salesReps = container.find('.sales-reps');

            salesReps.html('');
            loader.css('display', 'flex');

            $.ajax({
                url: '/SalesRep/GetFindARepData',
                method: 'GET',
                data: { 'countryCodeName': countryDropdown.val(), 'stateCodeName': stateDropdown.val(), 'zip': $(this).siblings('.zip-input').val() },
                success: function (resp) {
                    var data = JSON.parse(resp);

                    // update the sales rep list
                    var repsHtml = '';

                    if (data.Reps.length > 0) {
                        repsHtml = GetSalesRepsHtml(data.Reps);
                    }

                    // update sales rep listing
                    salesReps.html(repsHtml);

                    // hide loading icon
                    loader.hide();
                }
            });
        });

        $('.zip-input').keypress(function (e) {
            var keycode = (e.keyCode ? e.keyCode : e.which);

            if (keycode == '13') {
                $(this).siblings('.zip-filter-btn').click();
            }
        });

        $('.city-filter-btn').click(function () {
            var container = $(this).parents('.wt-sales-rep-widget__inner');
            var countryDropdown = $(this).parents('.sales-rep-filters').find('.country-dropdown');
            var stateDropdown = $(this).parents('.sales-rep-filters').find('.state-dropdown');
            var loader = container.find('.sales-rep-loader');
            var salesReps = container.find('.sales-reps');

            salesReps.html('');
            loader.css('display', 'flex');

            $.ajax({
                url: '/SalesRep/GetFindARepData',
                method: 'GET',
                data: { 'countryCodeName': countryDropdown.val(), 'stateCodeName': stateDropdown.val(), 'city': $(this).siblings('.city-input').val() },
                success: function (resp) {
                    var data = JSON.parse(resp);

                    // update the sales rep list
                    var repsHtml = '';

                    if (data.Reps.length > 0) {
                        repsHtml = GetSalesRepsHtml(data.Reps);
                    }

                    // update sales rep listing
                    salesReps.html(repsHtml);

                    // hide loading icon
                    loader.hide();
                }
            });
        });

        $('.city-input').keypress(function (e) {
            var keycode = (e.keyCode ? e.keyCode : e.which);

            if (keycode == '13') {
                $(this).siblings('.city-filter-btn').click();
            }
        });
    });
})


function GetSalesRepsHtml(reps) {
    var repsHtml = '';

    for (var x = 0; x < reps.length; x++) {
        repsHtml += '<div class="sales-rep"><div class="sales-rep__inner">';

        if (reps[x].RepImage != null) {
            repsHtml += '<div class="rep-img"><img src="' + reps[x].RepImage.DirectUrlOriginal + '" alt="' + reps[x].RepImage.AltText + '" /></div>';
        }

        repsHtml += '<div class="rep-content">'

        if (!IsNullOrEmpty(reps[x].RepTitle)) {
            repsHtml += '<div class="rep-name">' + reps[x].RepTitle + '</div>';
        }

        if (!IsNullOrEmpty(reps[x].RepFirstName) && !IsNullOrEmpty(reps[x].RepLastName)) {
            repsHtml += '<div class="rep-name">' + reps[x].RepFirstName + ' ' + reps[x].RepLastName + '</div>';
        }

        if (!IsNullOrEmpty(reps[x].RepBusinessUnit)) {
            repsHtml += '<div class="rep-business-unit text">' + reps[x].RepBusinessUnit + '</div>';
        }

        if (!IsNullOrEmpty(reps[x].RepAddress1)) {
            repsHtml += '<div class="rep-address1 text">' + reps[x].RepAddress1 + '</div>';
        }

        if (!IsNullOrEmpty(reps[x].RepAddress2)) {
            repsHtml += '<div class="rep-address2 text">' + reps[x].RepAddress2 + '</div>';
        }

        if (!IsNullOrEmpty(reps[x].RepCity) || !IsNullOrEmpty(reps[x].RepStateProvince)) {
            repsHtml += '<div class="rep-city-state text">';

            if (!IsNullOrEmpty(reps[x].RepCity)) {
                repsHtml += reps[x].RepCity;
            }

            if (!IsNullOrEmpty(reps[x].RepStateProvince)) {
                repsHtml += ', ' + reps[x].RepStateProvince;
            }

             repsHtml += '</div>';
        }

        if (!IsNullOrEmpty(reps[x].RepCountry)) {
            repsHtml += '<div class="rep-country text">' + reps[x].RepCountry + '</div>';
        }

        if (!IsNullOrEmpty(reps[x].RepPhoneNumber)) {
            repsHtml += '<div class="rep-phone text"><a href="tel:' + reps[x].RepPhoneNumber + '">' + reps[x].RepPhoneNumber + '</a></div>';
        }

        if (!IsNullOrEmpty(reps[x].RepEmail)) {
            repsHtml += '<div class="rep-email text"><a href="mailto:' + reps[x].RepEmail + '">' + reps[x].RepEmail + '</a></div>';
        }

        repsHtml += '</div>'; // closing .rep-content

        repsHtml += '</div></div>'; // closing .sales-rep__inner && .sales-rep
    }

    return repsHtml;
}

function IsNullOrEmpty(str) {
    if (str == undefined) return true;
    if (str == "") return true;
    if (str == null) return true;

    return false;
}